import React from "react";
import { icons } from "@img/icons";
import FilePreview from "./FilePreview";
import dateOfReturnFns from "@store/dateOfReturn";

/**
 * "Proof of Purchase" upload - the document(s) backing the Date of Purchase, sent
 * to the API as `dor_attachment`. Up to DOR_ATTACHMENT_MAX_FILES files,
 * images or PDF, each up to DOR_ATTACHMENT_MAX_SIZE_MB.
 *
 * Required, but like DateOfReturnField the empty check lives in the caller's
 * submit handler: the real input is hidden (common.css hides bare file inputs)
 * behind the `custom-file-upload` label, so `required` gives no usable prompt.
 *
 * `error` carries the backend's validation message for this field, which only
 * comes back on submit - shown inline rather than in a toast alone.
 */
const ProofOfReturnField = ({ files, onFileChange, onRemove, error }) => (
  <div className="form-field">
    <label htmlFor="dorAttachment">Proof of Purchase and/or Proof of Return (multiple attachments)</label>
    <div>
      <label htmlFor="dorAttachment" className="custom-file-upload">
        <img src={icons.Upload} alt="" /> Choose Files
      </label>
      <span>{files?.length ? "" : " No file chosen"}</span>
      <input
        accept="image/jpeg, image/png, application/pdf"
        type="file"
        id="dorAttachment"
        multiple
        aria-invalid={error ? "true" : undefined}
        aria-describedby={error ? "dorAttachment-error" : undefined}
        onChange={onFileChange}
      />
    </div>
    <div>
      <small className="text-muted">
        JPG, PNG or PDF - up to {dateOfReturnFns.DOR_ATTACHMENT_MAX_FILES}{" "}
        files, {dateOfReturnFns.DOR_ATTACHMENT_MAX_SIZE_MB}MB each
      </small>
    </div>

    {files?.length > 0 && (
      <div className="d-flex flex-row w-100 overflow-auto">
        {files.map((file, i) => (
          <FilePreview key={i} file={file} onRemove={onRemove} />
        ))}
      </div>
    )}

    {error && (
      <div id="dorAttachment-error" className="invalid-feedback d-block">
        {error}
      </div>
    )}
  </div>
);

export default ProofOfReturnField;
